module.exports = __webpack_public_path__ + "static/trumpet.ae680c6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/trumpet.svg
// module id = 456
// module chunks = 35783957827783 172322841747965